import React from 'react';
import { X } from './icons';

export type AlertVariant = 'success' | 'error' | 'warning' | 'info';

export interface AlertProps {
  children: React.ReactNode;
  variant?: AlertVariant;
  className?: string;
  onClose?: () => void;
}

const variantClasses: Record<AlertVariant, string> = {
  success: 'bg-green-50 text-green-800 border-green-200',
  error: 'bg-red-50 text-red-800 border-red-200',
  warning: 'bg-yellow-50 text-yellow-800 border-yellow-200',
  info: 'bg-blue-50 text-blue-800 border-blue-200',
};

export const Alert: React.FC<AlertProps> = ({
  children,
  variant = 'info',
  className = '',
  onClose
}) => {
  return (
    <div
      className={`p-4 rounded-lg border ${variantClasses[variant]} ${className} ${onClose ? 'flex items-start justify-between' : ''}`}
      role="alert"
    >
      <div className="flex-1">{children}</div>
      {onClose && (
        <button
          onClick={onClose}
          className="ml-4 flex-shrink-0 p-0.5 rounded hover:bg-black hover:bg-opacity-10 transition-colors"
          aria-label="Close"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};
